import React from "react";
import { formatNumber } from "../Utils/utils";
import List from "./list";

const CardFormVas = ({ items, openModalPdf }) => {
  let amount_neto = formatNumber.new(parseFloat(items.quote_amount));
  const fake = () => {
    return (
      <>
        <li className="cardFormVas__list">
          <b>Tasa:&nbsp;</b> 0%
        </li>
        <li className="cardFormVas__list__wrap">
          <b>Coberturas Principales</b>
          <ul className="cardFormVas__list__sub-list">
            <li>
              <b>Cobertura por sobrevivencia: Ninguna</b>
            </li>
            <li>
              <b>Cobertura por fallecimiento: Ninguna</b>
            </li>
          </ul>
        </li>
        <li className="cardFormVas__list__wrap">
          <b>Coberturas Adicionales</b>
          <ul className="cardFormVas__list__sub-list">
            <li>
              <b>Indemnización oncológica: Ninguna</b>
            </li>
            <li>
              <b>Cobertura adicional por fallecimiento accidental: Ninguna</b>
            </li>
          </ul>
        </li>
      </>
    );
  };
  return (
    <section className="modaldata">
      <div className="modaldata__content">
        <div className="modaldata__balance">
          <div className="balance__title">Saldo Esperado Neto</div>
          <span className="balance__currency">
            {items.money_vas === "PEN" ? "S/. " : "$ "}
          </span>
          <span className="balance__amount">
            {items.quote_amount ? amount_neto : 0}
          </span>
        </div>
        <List>
          {items.tasa && (
            <li className="cardFormVas__list">
              <b>Tasa:&nbsp;</b> {items.tasa.toFixed(2)}%
            </li>
          )}
          {items.toppings && (
            <li className="cardFormVas__list__wrap">
              <b>Coberturas Principales</b>
              <ul className="cardFormVas__list__sub-list">
                {items.toppings.map((res, key) => (
                  <div key={key}>
                    {key < 2 && (
                      <li>
                        <b>
                          {res.description}:{" "}
                          {res.price
                            ? `${
                                items.money_vas === "USD" ? "$ " : "S/. "
                              }${formatNumber.new(
                                parseFloat(res.price).toFixed(2)
                              )}`
                            : "Ninguno"}
                        </b>
                      </li>
                    )}
                  </div>
                ))}
              </ul>
            </li>
          )}
          {items.toppings && (
            <li className="cardFormVas__list__wrap">
              <b>Coberturas Adicionales</b>
              <ul className="cardFormVas__list__sub-list">
                {items.toppings.map((res, key) => (
                  <div key={key}>
                    {key >= 2 && (
                      <li>
                        <b>
                          {res.description}:{" "}
                          {res.price
                            ? `${
                                items.money_vas === "USD" ? "$ " : "S/. "
                              }${formatNumber.new(
                                parseFloat(res.price).toFixed(2)
                              )}`
                            : "Ninguno"}
                        </b>
                      </li>
                    )}
                  </div>
                ))}
              </ul>
            </li>
          )}

          {!items.toppings && fake()}
        </List>
        <div className="link-sep">
          <span className="modaldata__link" onClick={() => openModalPdf()}>
            Ver cotizaciones
          </span>
        </div>
      </div>
    </section>
  );
};
export default CardFormVas;
